export function getUserAgentOnClient(): string {
  return navigator.userAgent;
}
